'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _RelationshipModel = require('../model/RelationshipModel');

var _RelationshipModel2 = _interopRequireDefault(_RelationshipModel);

var _PickerControl = require('../../../lib/ui/PickerControl');

var _PickerControl2 = _interopRequireDefault(_PickerControl);

var _TextControl = require('../../../lib/ui/TextControl');

var _TextControl2 = _interopRequireDefault(_TextControl);

var _SelectPerson = require('../../person/action/SelectPerson');

var _SelectPerson2 = _interopRequireDefault(_SelectPerson);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RelationshipForm = function () {
  function RelationshipForm(element, args) {
    var _this = this;

    _classCallCheck(this, RelationshipForm);

    var fieldsetRelationship = document.createElement('fieldset');
    var legendRelationship = document.createElement('legend');
    legendRelationship.innerHTML = 'Relatie';
    fieldsetRelationship.appendChild(legendRelationship);

    this.id = args.relationship.values.id;
    var popup = null;

    this.person = new _PickerControl2.default(fieldsetRelationship, { label: 'Deze persoon', value: args.relationship.values.person_id,
      onchange: args.onchange,
      onselect: function onselect(item) {
        if (item.values.id) {
          window.PRIM.navigate('/people/' + item.values.id);
        }
      },
      onclick: function onclick() {
        var popupElement = document.getElementById('popup');
        var viewportElement = document.getElementById('viewport');

        popup = new _SelectPerson2.default(popupElement, {
          onok: function onok(item) {
            if (item && item.values.id) {
              _this.person.setValue(item.values.id, item);
            } else {
              _this.person.setValue(null, null);
            }

            viewportElement.classList.remove('invisible');
            popupElement.classList.add('invisible');
            popupElement.innerHTML = '';
            _this.person.onchange();
          },
          oncancel: function oncancel() {
            viewportElement.classList.remove('invisible');
            popupElement.classList.add('invisible');
            popupElement.innerHTML = '';
          }
        });
        viewportElement.classList.add('invisible');
        popupElement.classList.remove('invisible');
      }
    });
    this.target = new _PickerControl2.default(fieldsetRelationship, { label: 'De andere persoon', value: args.relationship.values.target_id,
      onchange: args.onchange,
      onselect: function onselect(item) {
        if (item.values.id) {
          window.PRIM.navigate('/people/' + item.values.id);
        }
      },
      onclick: function onclick() {
        var popupElement = document.getElementById('popup');
        var viewportElement = document.getElementById('viewport');

        popup = new _SelectPerson2.default(popupElement, {
          onok: function onok(item) {
            if (item && item.values.id) {
              _this.target.setValue(item.values.id, item);
            } else {
              _this.target.setValue(null, null);
            }

            viewportElement.classList.remove('invisible');
            popupElement.classList.add('invisible');
            popupElement.innerHTML = '';
            _this.person.onchange();
          },
          oncancel: function oncancel() {
            viewportElement.classList.remove('invisible');
            popupElement.classList.add('invisible');
            popupElement.innerHTML = '';
          }
        });
        viewportElement.classList.add('invisible');
        popupElement.classList.remove('invisible');
      }
    });
    this.description = new _TextControl2.default(fieldsetRelationship, { label: 'Omschrijving', value: args.relationship.values.description, readonly: window.PRIM.hasReadonlyModuleAccess('relationships'), onchange: args.onchange });

    var fragment = document.createDocumentFragment();
    fragment.appendChild(fieldsetRelationship);

    element.appendChild(fragment);
  }

  _createClass(RelationshipForm, [{
    key: 'getValue',
    value: function getValue() {
      var relationship = new _RelationshipModel2.default();
      relationship.person = this.person.getItem();
      relationship.target = this.target.getItem();
      relationship.values.id = this.id;
      relationship.values.person_id = this.person.getValue();
      relationship.values.target_id = this.target.getValue();
      relationship.values.description = this.description.getValue();
      return relationship;
    }
  }, {
    key: 'setValue',
    value: function setValue(relationship) {
      this.id = relationship.values.id;
      this.person.setValue(relationship.values.person_id, relationship.person);
      this.target.setValue(relationship.values.target_id, relationship.target);
      this.description.setValue(relationship.values.description);
    }
  }]);

  return RelationshipForm;
}();

exports.default = RelationshipForm;


//////////////////
// WEBPACK FOOTER
// ./js/modules/relationship/ui/RelationshipForm.js
// module id = 71
// module chunks = 0